var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.37495 2.1501L8.77495 10.5751C8.87495 10.6751 8.98328 10.7458 9.09995 10.7871C9.21662 10.8291 9.34162 10.8501 9.47495 10.8501C9.60828 10.8501 9.73328 10.8291 9.84995 10.7871C9.96662 10.7458 10.075 10.6751 10.175 10.5751L18.6 2.1501C18.8333 1.91676 18.95 1.6251 18.95 1.2751C18.95 0.925098 18.825 0.625098 18.575 0.375098C18.325 0.125098 18.0333 9.82285e-05 17.7 9.82285e-05C17.3666 9.82285e-05 17.075 0.125098 16.825 0.375098L9.47495 7.7251L2.12495 0.375098C1.89162 0.141765 1.60428 0.0250978 1.26295 0.0250978C0.920951 0.0250978 0.62495 0.150098 0.37495 0.400098C0.12495 0.650098 -4.95911e-05 0.941765 -4.95911e-05 1.2751C-4.95911e-05 1.60843 0.12495 1.9001 0.37495 2.1501V2.1501Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowDownWhite.f1dd87903998a8e1f7ce39a37c915316.svg";